exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-image-captcha .mask[data-v-6337fa30]{background:rgba(0,0,0,.5);position:fixed;top:0;right:0;bottom:0;left:0;margin:0;padding:0;z-index:999998}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6337fa30","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/captcha2/slideImageCaptcha.vue
// module id = 149
// module chunks = 0